import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  getMarkersWithCW,
  getNotificationMessage,
  markersSelectors,
  setFilters,
  usersSelectors,
  filterMarkers,
  handleOpenModal,
  setBlogRepostData,
  setChatSectionPage,
  setUserSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage
} from 'store'
import {
  FILTERS_TYPE,
  MODAL_SECTION,
  PENDING,
  REJECTED
} from 'utils/constants'
import { v4 as uuid } from 'uuid'

import { SearchBarInput } from 'components/SearchContainer/SearchBarInput'
import { isAuth } from 'utils/helpers'

export const SearchContainer = () => {
  const {
    activeProfile,
    filters,
    searchBar,
    userProfile
  } = useSelector(usersSelectors)
  const {
    getMarkersWithCWStatus,
    markers
  } = useSelector(markersSelectors)

  const [affinities, setAffinities] = useState([])
  const [codeWords, setCodeWords] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [isCodeWordSelect, setIsCodeWordSelect] = useState(false)

  const tempRecentSearch = JSON.parse(localStorage.getItem('recentSearches'))
  const [recentSearchesList, setRecentSearchesList] = useState(tempRecentSearch || [])

  const [isAffinityReplace, setIsAffinityReplace] = useState(false)
  const [searchValueArray, setSearchValueArray] = useState([])

  const dispatch = useDispatch()

  const normalizeValue = (value) => {
    if (value.startsWith('#')) {
      return value.slice(1)
    }

    return value
  }

  const DUPLICATE_MESSAGES = {
    [FILTERS_TYPE.Affinities]: 'Affinity already exist!',
    [FILTERS_TYPE.CodeWord]: 'Code Word already exist!',
    [FILTERS_TYPE.Own]: 'Search Input already exist!'
  }

  const handleChangeInput = async (e) => {
    if (
      getMarkersWithCWStatus !== PENDING
      && (
        e.keyCode !== 13
        || searchValue.length === 0
      )
    ) {
      return
    }

    if (
      !isAuth()
      || !activeProfile
    ) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'You do not have an active profile. Please setup your profile first.'
        })
      )

      return
    }

    const rawValue = searchValue.trim()
    const normalizedValue = normalizeValue(rawValue)
    const lowerValue = normalizedValue.toLowerCase()

    let itemTitle = ''
    let itemId = ''
    let type = ''
    if (isCodeWordSelect || rawValue.startsWith('#')) {
      const result = await dispatch(getMarkersWithCW({ title: normalizedValue }))
      const searchVal = result.meta.arg.title

      if (!result?.payload?.data) {
        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'Codeword should at most be 16 characters'
          })
        )
        return
      }

      const markersWithCW = result?.payload?.data
      let markerExisting = markers?.some((marker) => markersWithCW.includes(marker.id))

      if (!markerExisting) {
        markerExisting = userProfile?.some(
          (up) => up?.code_words?.some((cw) => cw.title === searchVal)
        )
      }

      itemTitle = `#${normalizedValue}`
      itemId = uuid()
      type = markersWithCW.length && markerExisting ? FILTERS_TYPE.CodeWord : FILTERS_TYPE.Own
    } else {
      const affinity = affinities.find((item) => item.title.toLowerCase() === lowerValue)

      let markerExisting = markers?.some(
        (marker) => marker.affinities.some((a) => a?.toLowerCase() === lowerValue)
      )
      if (!markerExisting) {
        markerExisting = userProfile?.some(
          (up) => up?.affinities?.some((a) => a?.title?.toLowerCase() === lowerValue)
        )
      }

      itemTitle = affinity?.title ?? rawValue
      itemId = affinity?.id ?? uuid()
      type = markerExisting ? FILTERS_TYPE.Affinities : FILTERS_TYPE.Own
    }

    const alreadyExists = searchValueArray.some(
      (item) => {
        if (isCodeWordSelect || item.title.startsWith('#')) {
          return item.title === rawValue
        }

        return item.title.toLowerCase() === itemTitle.toLowerCase()
      }
    )

    if (alreadyExists) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: DUPLICATE_MESSAGES[type]
        })
      )
      setSearchValue('')
      return
    }

    setSearchValueArray([
      ...filters,
      { title: itemTitle, id: itemId, type }
    ])

    setSearchValue('')

    if (type === FILTERS_TYPE.Affinities) {
      const updated = recentSearchesList.filter((item) => item !== itemTitle)

      updated.unshift(itemTitle)

      setRecentSearchesList(updated.slice(0, 5))
      setIsAffinityReplace((prev) => !prev)
    }

    setTimeout(() => {
      const ZoomCont = document.querySelector('.leaflet-control-zoom')
      const filterData = document.querySelector('.filter-data')
      const markerCountBox = document.querySelector('.marker-count')
      const markerPopupCont = document.querySelector('.leaflet-popup')

      ZoomCont.style.opacity = 1
      ZoomCont.style.pointerEvents = 'auto'
      filterData.style.opacity = 1
      filterData.style.pointerEvents = 'auto'

      if (markerPopupCont) {
        markerCountBox.style.opacity = 0
        markerCountBox.style.pointerEvents = 'none'
      } else {
        markerCountBox.style.opacity = 1
        markerCountBox.style.pointerEvents = 'auto'
      }
    }, 1000)
  }

  const addFilters = ({ title, type, id }) => {
    const exists = searchValueArray.some((item) => item.type === type && item.title === title)

    if (exists) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Affinity already exist!'
        })
      )
      setSearchValue('')
      return
    }

    setSearchValueArray([...filters, { title, id, type }])
    setSearchValue('')

    setTimeout(() => {
      const ZoomCont = document.querySelector('.leaflet-control-zoom')
      const filterData = document.querySelector('.filter-data')
      const markerCountBox = document.querySelector('.marker-count')
      const markerPopupCont = document.querySelector('.leaflet-popup')

      ZoomCont.style.opacity = 1
      ZoomCont.style.pointerEvents = 'auto'
      filterData.style.opacity = 1
      filterData.style.pointerEvents = 'auto'

      if (markerPopupCont) {
        markerCountBox.style.opacity = 0
        markerCountBox.style.pointerEvents = 'none'
      } else {
        markerCountBox.style.opacity = 1
        markerCountBox.style.pointerEvents = 'auto'
      }
    }, 1000)
  }

  const maxFiltersAlready = () => {
    dispatch(
      getNotificationMessage({
        type: REJECTED,
        message: 'You already entered the maximum number of filters.'
      })
    )
  }

  useEffect(() => {
    const searchAffinities = []
    const searchCodewords = []

    searchValueArray.forEach((item) => {
      if (item.type === FILTERS_TYPE.CodeWord) {
        searchCodewords.push(item.title.replace('#', ''))
      } else {
        searchAffinities.push(item.title)
      }
    })

    dispatch(setFilters(searchValueArray))

    if (isAuth()) {
      setTimeout(() => {
        dispatch(
          filterMarkers({
            affinities: searchAffinities,
            codewords: searchCodewords
          })
        )

        localStorage.setItem(
          'is-filtered',
          searchValueArray.length > 0
        )
      }, 0)
    }
  }, [searchValueArray])

  useEffect(() => {
    localStorage.setItem(
      'recentSearches',
      JSON.stringify(recentSearchesList)
    )
  }, [recentSearchesList, isAffinityReplace])

  useEffect(() => {
    setSearchValueArray((prev) => {
      if (prev === filters) {
        return prev
      }

      return [...filters]
    })

    if (filters?.length) {
      document.querySelector('#custom-popup-overlay')?.click()
      document.querySelector('#custom-popup-overlay-event')?.click()
      dispatch(setChatSectionPage('clear'))
      dispatch(setUserSectionPage('clear'))
      dispatch(setOpenPopupBlogs(false))
      dispatch(setOpenPopupEvents(false))
      dispatch(setNotificationSectionPage('clear'))
      dispatch(setBlogRepostData([]))
      dispatch(handleOpenModal({ isOpen: false, section: MODAL_SECTION?.RightSection }))
    }
  }, [filters])

  useEffect(() => {
    if (!isAuth()) {
      setRecentSearchesList([])
    }
  }, [isAuth()])

  useEffect(() => {
    if (searchBar.affinities) {
      setAffinities(searchBar.affinities)
    }

    if (searchBar.code_words) {
      setCodeWords(searchBar.code_words)
    }
  }, [searchBar])

  return (
    <SearchBarInput
      addFilters={addFilters}
      affinities={affinities}
      codeWords={codeWords}
      value={searchValue}
      setIsCodeWordSelect={setIsCodeWordSelect}
      isCodeWordSelect={isCodeWordSelect}
      setRecentSearchesList={setRecentSearchesList}
      recentSearchesList={recentSearchesList}
      setIsAffinityReplace={setIsAffinityReplace}
      isAffinityReplace={isAffinityReplace}
      onKeyDown={(e) => {
        if (filters.length < 3) {
          handleChangeInput(e)
        } else {
          maxFiltersAlready()
        }
      }}
      onChange={setSearchValue}
      width="300px"
      height="32px"
      name="search"
      maxFiltersAlready={maxFiltersAlready}
    />
  )
}
